var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxedText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 21 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13.75,
  height: 13.75,
  x: 3.458,
  y: 3.125,
  stroke: "#212529",
  strokeWidth: 1.25,
  rx: 0.875
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#212529",
  strokeWidth: 1.24,
  d: "M6.333 7.38h8M6.333 11.38h8"
})));
export default SvgBoxedText;